import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useAuth } from "@/store/auth";
import PasswordInput from "./password.vue";
import { isMobile } from "../Navbar/navState";

type Emits ={
	(e: 'moveToLogin'):void,
	(e: 'done'):void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'signup',
  emits: ["moveToLogin", "done"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const email = ref("");
const password = ref("");
const verifyPassword = ref("");
const canSubmit = computed(() => email.value && password.value && password.value === verifyPassword.value && password.value.length >= 6);

const error = ref<null | string>(null);
const loading = ref(false);

const auth = useAuth();

const performSignup = async () => {
	error.value = null;
	loading.value = true;

	const res = await auth.createUser(email.value, password.value);

	loading.value = false;
	if(res.success) {
		// GO SOMEWHERE ELSE
		emit('done');
	} else {
		error.value = res.reason!;
	}
};


const __returned__ = { emit, email, password, verifyPassword, canSubmit, error, loading, auth, performSignup, computed, ref, get useAuth() { return useAuth }, PasswordInput, get isMobile() { return isMobile } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})